import AppLayout from '../../components/Layout'
import React from 'react'

export default function Evaluation() {
  return (
    <div>Avaliação</div>
  )
}
